import { render, staticRenderFns } from "./PreprocessingRules.vue?vue&type=template&id=128a5535&"
import script from "./PreprocessingRules.vue?vue&type=script&lang=ts&"
export * from "./PreprocessingRules.vue?vue&type=script&lang=ts&"
import style0 from "./PreprocessingRules.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports